export const GET_SUBJECT_LIST = 'subject/getSubjectList';
export const GET_SUBJECT_LIST_SUCCESS = 'subject/getSubjectListSuccess';
